import { Accordion, AccordionDetails, AccordionSummary, Box, Grid, Tooltip, Typography, useMediaQuery } from "@mui/material";
import React, { useEffect, useState } from "react";
import { Swiper, SwiperSlide } from 'swiper/react';
import { Navigation, Pagination } from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';
import instId from "./network/instituteId";
import Network from "./network/Network";
import { useNavigate } from "react-router-dom";


export const ClassRoomCourses = ({ endpointsUrl }) => {

    const navigate = useNavigate();
    const isMobile = useMediaQuery("(min-width:600px)");
    const [shortsList, setShortsList] = useState([]);
    const [peviewImgVideo, setPeviewImgVideo] = useState({});
    const [coursesList, setCoursesList] = useState([]);
    const [filterCourse, setFilterCourse] = useState([]);


    useEffect(() => {
        getAllCourses();
    }, []);

    useEffect(() => {
        if (coursesList?.length > 0) {
            const filterCourseTags = coursesList.filter(item => {
                const tagslists = item.tags || [];
                if (tagslists.some(tag => tag.tag === "Classroom Test Series")) {
                    return item
                }
            });

            setFilterCourse(filterCourseTags);
        }
    }, [coursesList])

    const getAllCourses = async () => {
        const response = await Network.fetchCourses(instId);
        const course = response?.courses;
        const filterCourses = course?.filter((item) =>
            item?.active === true
        );
        setCoursesList(filterCourses);
    };

    const handleCourseClick = (item) => {
        const courseId = item?.id;
        navigate(`/classroom-courses?courseId=${courseId}`)
        // if (courseId) {
        //     window.open(`http://gst.vsmarttestseries.com?courseId=${courseId}`, '_blank');
        // }
    };

    return (
        <div style={{ paddingLeft: isMobile ? '10rem' : '1rem', paddingRight: isMobile ? '10rem' : '1rem', paddingTop: isMobile ? '8rem' : '1rem', paddingBottom: isMobile ? '8rem' : '1rem', position: "relative" }}>
            <Grid container spacing={2} sx={{ pl: 2, pr: 2 }}>
                <Grid item xs={12} sm={12} md={12} lg={12}>
                    <Typography
                        sx={{ mb: 3, mt: 4, color: "black", textAlign: "center", padding: "10px" }}
                        fontSize={'16px'}
                        fontWeight={'bold'}
                    >Explore Faculty Wise Classroom Test Series</Typography>
                    <Grid container spacing={2}>
                        {
                            filterCourse?.length > 0 && filterCourse?.map((item, i) => {
                                return (<Grid item xs={12} sm={4} md={4} lg={4} key={i} direction={'column'}

                                    sx={{
                                        borderRadius: '10px',
                                        padding: '1rem',
                                        width: '100%',
                                        cursor: 'pointer',
                                    }}
                                >
                                    <Box display={'flex'} justifyContent={'center'} alignItems={'center'}
                                        onClick={() => handleCourseClick(item)}
                                    >
                                        <img
                                            src={item?.logo ? endpointsUrl + item?.logo : "img/folder-2.png"}
                                            style={{ width: "100%", height: '100%', minHeight: '200px', borderRadius: '10px', boxShadow: "rgba(0, 0, 0, 0.35) 0px 5px 15px" }}
                                        />
                                    </Box>

                                </Grid>

                                )
                            })
                        }
                    </Grid>
                </Grid>
            </Grid>
        </div>
    );
};
